import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Nav from './Nav';
import Footer from './Footer';

/** Every navigation starts at the top of the new page. */
function useScrollReset() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}

export default function Layout() {
  useScrollReset();

  return (
    <>
      <Nav />
      <Outlet />
      <Footer />
    </>
  );
}
